import { QuestionBase } from './question-base.model';

export class CompositeArrayQuestion extends QuestionBase<string> {
    controlType = 'composite-array';
    resource: string;
    arrayLimit: number;
    visible: string;
    buttonText: string;
    buttonProps: any;
    decorator: string;
    bannerJson: any;
    valid: any;
    minWidth: string;
    dependentField: string;
    dependentFieldMap: any[];
    replace_items: string;
    item_key: string;
    populateField: any;
    show_label: any;
    hideDelete: boolean;
    hideAdd: boolean;
    hideform: boolean;
    hideEdit:boolean;
    view_mode:boolean;
    expression: any;
    templateInterceptor: any;
    button: any;
    filters: any;
    btnConditions: any;
    error_message: any;
    persist_position: Boolean;
    showLastAddedAtTop: Boolean;
    compositePopup: boolean;
    update_list_outsource: Boolean;
    multiselect: any;
    pagination_enabled: boolean;
    complex_search: any;
    hide_edit_conditions: boolean;
    hide_delete_conditions: boolean;
    config_add: any;

    constructor(options: {} = {}) {
        super(options);
        this.resource = options['resource'];
        this.arrayLimit = options['arrayLimit'];
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.buttonText = options['buttonText'] || "Add new";
        this.buttonProps = options['buttonProps'] || { buttonClass: 'primary-btn' };
        this.decorator = options['decorator'] || "";
        this.bannerJson = options['bannerJson'];
        this.valid = options['valid'];
        this.minWidth = options['minWidth'] || 'auto';
        this.dependentField = options["dependentField"] || "";
        this.dependentFieldMap = options["dependentFieldMap"] || [];
        this.replace_items = options["replace_items"] || "";
        this.item_key = options["item_key"] || "";
        this.populateField = options["populateField"] || "";
        this.conditions = options["conditions"] || "";
        this.btnConditions = options["btnConditions"] || "";
        this.show_label = options["show_label"];
        this.multiselect = options["multiselect"];
        this.hideDelete = options['hideDelete'] || false;
        this.hide_edit_conditions = options['hide_edit_conditions'] || false;
        this.hide_delete_conditions = options['hide_delete_conditions'] || false;
        this.hideAdd = options['hideAdd'] || false;
        this.hideEdit = options['hideEdit'] || false;
        this.hideform = options['hideform'] || false;
        this.view_mode = options['view_mode'] || false;
        this.compositePopup = options['compositePopup'] || false;
        this.expression=options['expression'] || false;
        this.templateInterceptor = options['templateInterceptor'] || false;
        this.button = options['button']||false;
        this.filters = options['filters'] || false;
        this.error_message = options['error_message'] || false;
        this.persist_position = options['persist_position'] || false;
        this.showLastAddedAtTop = options['showLastAddedAtTop'] || false;
        this.update_list_outsource = options['update_list_outsource'] || false;
        this.pagination_enabled = options['pagination_enabled'] || false;
        this.complex_search = options['complex_search'];
        this.config_add = options['config_add'];
    }
}
